import { Cell } from '@pelckmans/elementis/components/table/cell';
import { Score } from '../../../api/results';
import { ScorableItem } from '../../../api/scorable-items';

export default function AbsoluteScoreCell({
  scorableItem,
  score,
  needsGrading,
}: {
  scorableItem: ScorableItem;
  score?: Score['score'];
  needsGrading?: boolean;
}) {
  const showAbsoluteScore = scorableItem.showPoints && score?.maximum && !needsGrading;
  return (
    <Cell minWidth="sm" maxWidth="sm">
      {showAbsoluteScore ? <Cell.Text title={`${score.achieved} / ${score.maximum}`} /> : null}
    </Cell>
  );
}
